var map = {
	"./servicos/automacao.svg": 880,
	"./servicos/execucao.svg": 506,
	"./servicos/orcamento.svg": 280,
	"./servicos/projetos.svg": 641,
	"./servicos/solar.svg": 600,
	"./servicos/startup.svg": 806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;